import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import styled from "styled-components"

import BackgroundImage from "gatsby-background-image"
import Img from "gatsby-image"

const query = graphql`
  {
    file(relativePath: { eq: "homeImage.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
const Background = ({ className, children }) => {
  const data = useStaticQuery(query)
  const {
    file: {
      childImageSharp: { fluid },
    },
  } = data
  return (
    <BackgroundImage
      Tag="section"
      className={className}
      fluid={fluid}
      backgroundColor={`#040e18`}
    >
      {children}
    </BackgroundImage>
  )
}

export const ImageBackGround = styled(Background)`
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  background-attachment: scroll;
  
   
  height: 100%;
  width: 100%;

  display: flex;
  align-items: flex-end;
  flex-direction: column;
  /* justify-content: space-between; */
  text-align: right;
  top: 0;
  left: 0;
  background-color: var(--clr-primary-1);

  

  @media screen and (max-width: 979px) {
    display: ${props => props.keepOpened? 'none' : 'flex'};
    width: 100%;
    height: 100%;
    text-align: center;
  }
  
`
export const SideDiv = styled.div`
  position: fixed;
  height: 100vh;
  width: 35%;
  @media screen and (max-width: 979px) {
    position:static;
    width: 100%;
    height: 100%;
  }
`
export const Wrapper = styled.div`
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600&display=swap');
  height: 100%;
  width: 100vw;
  display: flex;
  min-height:0;
  margin-top: -5rem;
  

  @media screen and (max-width: 979px) {
    flex-direction: column;
  }
`

export const InnerDiv = styled.div`
  width: 100%;
  align-self: flex-start;
  height: 100%;
  margin: 10rem 0 2em 0;

  h1 {
    color: rgba(255,255,255,0.5);
    font-size: 1.35em;
    line-height: 1.65em;
    margin: 3rem 3rem 0 5rem;
    text-transform: none;
    font-family: 'Quicksand', sans-serif;
    font-weight: 350;
  }
  h1 strong {
    color: #ffffff;
    font-weight: 500;
  }
  @media screen and (max-width: 979px) {
    margin: 9rem 0 2em 0;
    h1 {
      font-size: 1.75em;
      margin: 2rem 3rem 0 5rem;
    }
  }
  @media screen and (max-width: 400px) {
    h1 {
      font-size: 1.35em;
      margin: 2rem 3rem 0 5rem;
      font-weight: 500;
      line-height: 1.25em;
      color: rgba(255,255,255,0.65);
    }
  }
`
export const Image = styled(Img)`
  border-radius: 50%;
  margin: 0 3rem 0 0;
  @media(hover: hover) and (pointer: fine) {
    &:hover{
    transition: all 0.3s ease-out;
    transform: scale(1.2, 1.2);
  }
}
  
  @media screen and (max-width: 979px) {
    margin: 0;
  }
`